import { Pipe, PipeTransform } from '@angular/core';
import { ThemeService } from '../services/theme.service';

@Pipe({
  name: 'brandName',
  pure: false, // Not pure because it depends on theme service state
})
export class BrandNamePipe implements PipeTransform {
  constructor(private themeService: ThemeService) {}

  transform(value: string): string {
    if (!value) {
      return value;
    }

    const appName = this.themeService.appName;

    // Use a single regex with alternation to match both "Pencil Spaces" and "Pencil"
    // The alternation ensures "Pencil Spaces" is matched first (longest match wins)
    return value.replace(/(pencil spaces|pencil)/gi, appName);
  }
}
